import { Box, Tooltip } from '@material-ui/core';
import { LenderName } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { LenderIcon } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';
import { useScreen } from '@/hooks/useScreen';

interface LenderIconsProps {
  allLenderNames: LenderName[];
  activeLenderNames: LenderName[];
  size?: number;
  collapseAfter?: number;
  collapseOnlyOnLargeScreen?: boolean;
}

export const LenderIcons = ({
  allLenderNames,
  activeLenderNames,
  size = 20,
  collapseAfter = 100,
  collapseOnlyOnLargeScreen = true,
}: LenderIconsProps) => {
  const { lg } = useScreen();

  const sortedLenderNames = [...allLenderNames];
  const mustCollapse = collapseOnlyOnLargeScreen
    ? lg && allLenderNames.length > collapseAfter
    : allLenderNames.length > collapseAfter;

  if (!mustCollapse) {
    return (
      <Box display={'flex'} alignItems={'center'} gridGap={size / 2}>
        <LenderLogosList lenderNames={sortedLenderNames} activeLenderNames={activeLenderNames} size={size} />
      </Box>
    );
  }

  sortedLenderNames.sort((a, b) => {
    const aIsActive = activeLenderNames.indexOf(a) !== -1;
    const bIsActive = activeLenderNames.indexOf(b) !== -1;
    if (aIsActive && bIsActive) return 0;
    if (aIsActive) return -1;
    return 1;
  });

  return (
    <Tooltip
      title={
        <Box display={'flex'} alignItems={'center'} gridGap={size / 2} p={1}>
          <LenderLogosList
            lenderNames={sortedLenderNames.slice(collapseAfter - sortedLenderNames.length)}
            activeLenderNames={activeLenderNames}
            size={size}
          />
        </Box>
      }
    >
      <Box display={'flex'} alignItems={'center'} gridGap={size / 2}>
        <LenderLogosList
          lenderNames={sortedLenderNames.slice(0, collapseAfter)}
          activeLenderNames={activeLenderNames}
          size={size}
        />
        <Font variant="body2" color="textSecondary">
          {` +${sortedLenderNames.length - collapseAfter}`}
        </Font>
      </Box>
    </Tooltip>
  );
};

interface LenderLogosListProps {
  lenderNames: LenderName[];
  activeLenderNames: LenderName[];
  size?: number;
}

const LenderLogosList = ({ lenderNames, activeLenderNames, size }: LenderLogosListProps) => {
  return (
    <>
      {lenderNames.map((lenderName) => (
        <LenderIcon
          key={lenderName}
          lenderName={lenderName}
          isActive={activeLenderNames.includes(lenderName)}
          size={size}
        />
      ))}
    </>
  );
};
